import {
    blue50,
    blue100,
    green50,
    green100,
    green600,
    greyishBlue100,
    greyishBlue200,
    greyishBlue500,
    greyishBlue700,
    orange50,
    orange100,
    orange500,
    red50,
    red100,
    red500,
    purpleColor,
    blue500
} from "assets/jss/main";
import {LineItemStatus} from "utils/LineItemStatus";

const makeStatusTheme = (main, light, borderColor) => ({
    palette: {
        statusColor: {main, light}
    },
    border: {
        statusColor: {main: borderColor}
    }
});

export const LineItemStatusBadgeStyle = {
    [LineItemStatus.PENDING]:            makeStatusTheme('#C37607',      '#FEF3E3',        '#EDDFCA'), // No equivalent colors were found
    [LineItemStatus.RESERVED]:           makeStatusTheme(purpleColor,      '#F4E3FE',           '#DACAED'),
    [LineItemStatus.TO_SHIP]:            makeStatusTheme(blue500,       blue50,          blue100),
    [LineItemStatus.CONFIRMED]:          makeStatusTheme(green600,       green50,          green100),
    [LineItemStatus.RETURNING_RETAILER]: makeStatusTheme('#C45318',      orange50,         orange100),
    [LineItemStatus.RETURNING_RUNNER]:   makeStatusTheme(orange500,      orange50,         orange100),
    [LineItemStatus.RETURNED]:           makeStatusTheme(greyishBlue700, greyishBlue100,   greyishBlue200),
    [LineItemStatus.CANCELED]:           makeStatusTheme(red500,         red50,            red100),
    [LineItemStatus.UNAVAILABLE]:        makeStatusTheme(greyishBlue500, greyishBlue200,   greyishBlue200),
};